import { render } from "./ChankangMeal.vue?vue&type=template&id=f31d8f20&ts=true"
import script from "./ChankangMeal.vue?vue&type=script&lang=ts"
export * from "./ChankangMeal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__